const appTheme = require("./theme");
const appConfig = require("./app.json")

var app = appConfig;
var tbTheme = appTheme
if (window.theme) {
    tbTheme = window.theme;
}

if (window.appConfig) {
    app = window.appConfig;
}

module.exports = {
    app,
    tbTheme
}